import {useEffect} from 'react';

export default function BlogPage({title, content, page}) {
  useEffect(() => {
    dataLayer.push({
      event: 'view_content',
      content_name: title,
      content_type: content,
    });

    dataLayer.push({
      event: 'start_reading', //Static data
      item_id: page._id, //Dynamic data
      item_name: title, //Dynamic data
      item_category: page.categories ? page.categories[0].name : null, //Dynamic data
    });
  }, []);
}
